import { Component, ChangeDetectionStrategy, Input, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CookiePreferences, getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { Observable, of } from 'rxjs';
import { filter, tap, take, switchMap } from 'rxjs/operators';
import { InstaPost } from 'src/app/instagram/models';
import { getInstaPostsLoaded, getOrderedInstaPosts, LoadInstaPosts } from 'src/app/instagram/store';
import { ContentBlock } from '../../models';
import { ContentBlockFeaturedCollectionComponent } from '../../components/content-block-featured-collection/content-block-featured-collection.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { ContentBlockFeaturedProductsComponent } from '../../components/content-block-featured-products/content-block-featured-products.component';
import { ContentBlockWysiwygComponent } from '../../components/content-block-wysiwyg/content-block-wysiwyg.component';
import { ContentBlockWithImagesComponent } from '../../components/content-block-with-images/content-block-with-images.component';
import { ContentBlockProductCatalogComponent } from '../../components/content-block-product-catalog/content-block-product-catalog.component';
import { ContentBlockFaqComponent } from '../../components/content-block-faq/content-block-faq.component';
import { ContentBlockInstagramFeedComponent } from '../../components/content-block-instagram-feed/content-block-instagram-feed.component';
import { InstagramFeedComponent } from '../../../instagram/components/instagram-feed/instagram-feed.component';

@Component({
  selector: 'app-content-block-container',
  templateUrl: './content-block-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContentBlockFeaturedCollectionComponent,
    NgClass,
    ContentBlockFeaturedProductsComponent,
    ContentBlockWysiwygComponent,
    ContentBlockWithImagesComponent,
    ContentBlockProductCatalogComponent,
    ContentBlockFaqComponent,
    ContentBlockInstagramFeedComponent,
    InstagramFeedComponent,
    AsyncPipe,
  ],
})
export class ContentBlockContainerComponent implements OnInit {
  private store = inject(Store);

  @Input() blocks: ContentBlock[] = [];
  cookiePreferences$?: Observable<CookiePreferences | null>;
  instaPosts$: Observable<InstaPost[]> = of([]);

  ngOnInit(): void {
    this.cookiePreferences$ = this.store.select(getCookiePreferences);

    if (this.blocks.filter(block => block.blockType === 'instagram-feed').length > 0) {
      this.getInstaFeed();
    }
  }

  trackByFn(index: number, block: ContentBlock) {
    return block.id;
  }

  getInstaFeed() {
    this.instaPosts$ = this.checkInstaPostsLoaded().pipe(switchMap(() => this.store.select(getOrderedInstaPosts)));
  }

  checkInstaPostsLoaded(): Observable<boolean> {
    return this.store.select(getInstaPostsLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(LoadInstaPosts());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
